import { h } from 'preact';
import classNames from 'classnames';
import './style.scss';

const Tabs = ({activeService, setActiveService}) => {

  const handleClick = (e) => {
    e.preventDefault();
    setActiveService(e.target.dataset.service);
  }
 return (
  <div className="tabs">
    <button
      type="button"
      className={classNames('tabs__item', {
        'active': activeService === 'programming'
      })}
      onClick={(e) => handleClick(e)}
      data-service="programming"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="https://www.w3.org/2000/svg">
        <path d="M13.3333 15L18.3333 10L13.3333 5" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.66666 5L1.66666 10L6.66666 15" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Programming
    </button>
    <button
      type="button"
      className={classNames('tabs__item', {
        'active': activeService === 'calculations'
      })}
      onClick={(e) => handleClick(e)}
      data-service="calculations"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="https://www.w3.org/2000/svg">
        <path d="M3.29105 7.5H16.4552" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.29105 12.5H16.4552" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.22762 2.5L6.58209 17.5" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.1642 2.5L11.5187 17.5" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Calculations
    </button>
  </div>
 );
};

export default Tabs;
